<div id="academy-course" class="page-layout simple left-sidebar inner-scroll">

    <!-- SIDEBAR -->
    <fuse-sidebar class="sidebar" name="sidebarWizardCGO" position="left" lockedOpen="gt-md">

        <!-- HEADER -->
        <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">

            <!-- <button mat-icon-button class="sidebar-toggle mr-16" fxHide.gt-md
                  (click)="toggleSidebar('sidebarWizardCGO')">
              <mat-icon>menu</mat-icon>
          </button> -->
            <!-- <div style="flex: 2 0 0;">
                <h1>{{course.title}}</h1>
            </div>
 -->
            <div style="flex: 2 0 0;">
                <h1>{{tituloProducto | translate}}</h1>
                <span class="updated secondary-text">{{'WIZARD.LANDING.DONE' | translate}}{{anioProducto}}</span>
            </div>

            <button fxHide.gt-md style="flex: 1 0 0;" mat-icon-button class="mr-16" fxLayoutAlign="end center" (click)="toggleSidebar('sidebarWizardCGO')">
              <mat-icon>arrow_back</mat-icon>
          </button>

        </div>
        <!-- / HEADER -->

        <!-- SIDEBAR CONTENT -->
        <div class="content" fusePerfectScrollbar>

            <div class="steps">

                <ng-container *ngFor="let step of pasosWizard; let i = index; let last = last; let first = first;">

                    <div class="step" [@animate]="{value:'*',params:{delay:'200ms', y:'25px'}}" *ngIf="step.visible && step.status != 1; else sinAcceso" (click)="gotoStep(i);toggleSidebar('sidebarWizardCGO')" [routerLink]="step.ruta" [ngClass]="{'seleccionado': currentStep === i,
                                'completed': step.status === 3,
                                'bloqueado': step.status === 1,
                                'last': last, 'first': first}">
                        <!-- [ngClass]="{'current': currentStep === i, 'completed': currentStep > i, 'last': last, 'first': first}" -->
                        <div class="index">
                            <span><mat-icon>{{step.icon}}</mat-icon></span>
                        </div>
                        <div class="title">{{step.title | translate}}</div>

                        <div class="length">
                            <mat-icon *ngIf="step.status == 2 && stpAllOk" class="length-icon pending s-30" matTooltip="{{'WIZARD.STEPSTAT.PEND' | translate}}">{{iconoStep.pending}}</mat-icon>
                            <mat-icon *ngIf="step.status == 3 && stpAllOk" class="length-icon done s-30" matTooltip="{{'WIZARD.STEPSTAT.COMP' | translate}}">{{iconoStep.done}}</mat-icon>
                        </div>

                    </div>

                    <!------------------------------>

                    <ng-template #sinAcceso>
                        <div *ngIf="step.visible" class="step" [@animate]="{value:'*',params:{delay:'200ms', y:'25px'}}" (click)="aletaRestric(i)" [ngClass]="{'seleccionado': currentStep === i,
                                    'completed': step.status === 3,
                                    'bloqueado': step.status === 1,
                                    'last': last, 'first': first}">
                            <div class="index">
                                <span><mat-icon>{{step.icon}}</mat-icon></span>
                            </div>
                            <div class="title">{{step.title | translate}}</div>

                            <div class="length">
                                <mat-icon *ngIf="step.status == 1 && stpAllOk" class="length-icon undone s-30" matTooltip="{{'WIZARD.STEPSTAT.LOCK' | translate}}">{{iconoStep.undone}}</mat-icon>
                                <mat-spinner *ngIf="!stpAllOk" diameter="30"></mat-spinner>
                            </div>

                        </div>
                    </ng-template>
                </ng-container>
            </div>

        </div>
        <!-- / SIDEBAR CONTENT -->

    </fuse-sidebar>
    <!-- / SIDEBAR -->

    <!-- CENTER -->
    <div class="center">

        <!-------- header para vista en moviles---------->
        <div fxLayout="row" fxLayoutAlign="start center" class="accent" fxHide.gt-md>
            <button style="flex: 1 0 0;" mat-icon-button class="sidebar-toggle mr-16" fxHide.gt-md (click)="toggleSidebar('sidebarWizardCGO')">
            <mat-icon>menu</mat-icon>
          </button>

            <div style="flex: 2 0 0;">
                <h2>{{tituloProducto | translate}}</h2>
            </div>
        </div>


        <!-- CONTENT -->
        <div id="course-content" class="content">

            <ng-container *ngFor="let step of pasosWizard; let i = index;">

                <!-- <div class="course-step" fusePerfectScrollbar
                     *ngIf="currentStep === i"
                     [@slideIn]="animationDirection"> -->


                <!--div id="course-step-content" class="course-step-content" [innerHTML]="step.content"></div-->
                <!-- <div id="course-step-content" class="course-step-content"><router-outlet></router-outlet></div> -->

                <!-- ------contenido------ -->
                <div class="page-layout carded fullwidth inner-scroll cursoStep" *ngIf="currentStep === i" [@slideIn]="animationDirection">
                    <!-- TOP BACKGROUND -->
                    <div class="top-bg"></div>
                    <!-- CENTER -->
                    <div class="center">
                        <!-- CONTENT HEADER -->
                        <div class="cabeceraVideo" fxLayout="row" fxLayoutAlign="start center">
                            <!-- <div class="header p-24" fxLayout="row" fxLayoutAlign="start center"> -->
                            <!-- <video autoplay muted loop class="videoBG">
                            <source id="videoBanner{{i}}" src="assets/video/wizard/certificar/banner/{{idiomaActual}}/{{step.videoBanner}}.mp4" type="video/mp4">
                          </video> -->
                            <video autoplay muted loop class="videoBG" id="videoBanner{{i}}">
                          </video>
                            <!-- <h2 class="m-0">{{step.tituloPagina | translate}} </h2> -->
                        </div>
                        <!-- CONTENT CARD -->
                        <div class="content-card" [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">
                            <!-- CONTENT TOOLBAR -->
                            <div class="toolbar primary px-24 py-8">
                                <span>{{step.subtiPagina | translate}}</span>
                                <!-- <div class="length" *ngIf="step.status == 3">
                                    <mat-icon class="length-icon done s-40" matTooltip="{{'WIZARD.STEPSTAT.COMP' | translate}}">done</mat-icon>
                                </div> -->
                                <!-- <div class="length">
                                  <button mat-raised-button color="primary" (click)="enviarCorreos()"><mat-icon *ngIf="i==1" class="length-icon done s-30" matTooltip="enviar correos" >send</mat-icon></button>
                                </div> -->
                            </div>
                            <!-- CONTENT -->
                            <div class="content" fusePerfectScrollbar>

                                <div class="course-step-content">
                                    <router-outlet style="width:100%;"></router-outlet>

                                </div>

                            </div>

                        </div>
                    </div>
                </div>

                <!-- ------contenido------ -->

                <!-- </div> -->

            </ng-container>

        </div>
        <!-- / CONTENT -->

    </div>
    <!-- / CENTER -->

</div>
